module.exports = __webpack_public_path__ + "img/BeastMaster.0f9d68e7.png";